export const POPUP_TIMER_ADD = "POPUP_TIMER_ADD";
export const POPUP_TIMER_REMOVE = "POPUP_TIMER_REMOVE";
